export const PROCTOR_STOPPED_MESSAGE = 'Session Finished/Stopped by Proctor. Please contact support.';

export function normalizeProctoringMessage(value) {
  const message = typeof value === 'string'
    ? value
    : value?.msg ?? value?.message ?? '';
  if (/session finished\/stopped by proctor/i.test(message)) {
    return PROCTOR_STOPPED_MESSAGE;
  }
  if (/cannot read properties of null.*session/i.test(message)) {
    return PROCTOR_STOPPED_MESSAGE;
  }
  return message || '';
}

export function isProctorStoppedMessage(value) {
  return normalizeProctoringMessage(value) === PROCTOR_STOPPED_MESSAGE;
}
